ALLOWED_CONTROLLER = 'info'
ALLOWED_ACTIONS = ['contact', 'submit_contact']

ready = ->
  return unless continueIfAllowed(ALLOWED_CONTROLLER, ALLOWED_ACTIONS)

  $('select').on 'change', ->
    if $('select').val() == 'My card is not working' || $('select').val() == 'Equipment is broken or not working'
      $('*[data-selector="card_number_paragraph"]').show()
    else
      $('*[data-selector="card_number_paragraph"]').hide()


$(document).ready(ready)
$(document).on('turbo:load', ready)
